import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CancelIcon } from "../assets/svg";
import { GRAY_SCALE } from "../theme/colors";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import React from "react";
import { LoadingButton } from "@mui/lab";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export const errorFormField = (methodForm, errors) => {
  if (errors && Array.isArray(errors?.error_fields)) {
    errors.error_fields.forEach((item) => {
      methodForm.setError(item.field, {
        type: "custom",
        message: item.error_msg,
      });
    });
  }
};

export const successMsg = (msg) => {
  if (msg)
    toast(<SuccessMessage message={msg} />, {
      closeButton: () => (
        <div className="px-12 my-auto border-l">
          <CloseOutlinedIcon fontSize="10" />
        </div>
      ),
      className: "vds-toast__success",
    });
};

export const errorMsg = (error, defaultMsg = "message.sys-error") => {
  if (error instanceof Error) {
    toast(<ErrorMessage message={error.message} />, {
      closeButton: () => (
        <div className="px-12 my-auto border-l">
          <CloseOutlinedIcon fontSize="small" />
        </div>
      ),
      className: "vds-toast__error",
    });
  } else if (error instanceof Object && error.error_msg) {
    // NotificationManager.error(msg.error_msg)
    toast(<ErrorMessage message={error.error_msg} />, {
      // closeButton: () => <div className="px-12 pt-16 border-l">Close</div>,
      className: "vds-toast__error",
    });
  } else if (typeof error === "string") {
    // NotificationManager.error(msg)
    toast(<ErrorMessage message={error} />, {
      closeButton: () => (
        <div className="px-12 my-auto border-l">
          <CloseOutlinedIcon fontSize="small" />
        </div>
      ),
      className: "vds-toast__error",
    });
  } else if (error.errors && Array.isArray(error.errors)) {
    error.errors.forEach((el) => {
      return toast(<ErrorMessage message={el.error_message} />, {
        className: "vds-toast__error",
      });
    });
  } else {
    toast(<ErrorMessage message={defaultMsg} isTranslate />, {
      // closeButton: () => <div className="px-12 pt-16 border-l">Close</div>,
      className: "vds-toast__error",
    });
  }
};
export const errorMsgVss = (errorCodes, title) => {
  // (t) => {
  //     const { deleteToast, toastId } = t.toastProps || {};
  //     const handle = async (fnHandle) => {
  //       !!fnHandle && (await fnHandle());
  //       deleteToast();
  //     };
  toast(
    (t) => {
      const { toastId } = t.toastProps || {};
      return (
        <ErrorMessageVss key={toastId} errorCodes={errorCodes} title={title} />
      );
    },
    {
      closeButton: () => (
        <div className="px-12 my-auto border-l">
          <CloseOutlinedIcon fontSize="small" />
        </div>
      ),
      className: "vds-toast__error",
    }
  );
};
const ErrorMessageVss = ({ errorCodes, title }) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center">
      <img alt="" src={CancelIcon} />
      <div className="px-6 vds-toast__msg" style={{ color: "#242424" }}>
        <Typography variant="subtitle2" className="mb-3">
          {title ?? t("message.fail")}
        </Typography>
        {errorCodes?.map(({ message, code }, index) => (
          <React.Fragment key={`${code}-${index}`}>
            <Typography variant="body2" style={{ color: "#747475" }}>
              {message}
            </Typography>
          </React.Fragment>
        ))}
      </div>
      <Divider orientation="horizontal" light={true} variant="middle" />
    </div>
  );
};
const ErrorMessage = ({ message, title = null, isTranslate = false }) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center">
      <img alt="" src={CancelIcon} />
      <div className="px-6 vds-toast__msg" style={{ color: "#242424" }}>
        <Typography variant="subtitle2" className="mb-3">
          {title ?? t("message.fail")}
        </Typography>
        <Typography variant="body2" style={{ color: "#747475" }}>
          {isTranslate ? t(message) : message}
        </Typography>
      </div>
      {/* <Divider orientation="horizontal" color={GRAY_SCALE} width={1} /> */}
    </div>
  );
};

export const SuccessMessage = ({ message, title = null }) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center">
      <CheckCircleOutlinedIcon
        style={{ height: 42, width: 42 }}
        color="primary"
      />
      <div className="px-12 vds-toast__msg" style={{ color: "#242424" }}>
        <Typography variant="subtitle2" className="mb-3">
          {title ?? t("message.success")}
        </Typography>
        <Typography variant="body2" style={{ color: "#747475" }}>
          {message}
        </Typography>
      </div>
    </div>
  );
};

export const toastConfirm = ({
  title,
  message,
  handleBtnLeft = () => {},
  handleBtnRight = () => {},
  textBtnLeft = "Ok",
  textBtnRight = "Cancel",
}) => {
  return toast(
    (t) => {
      const { deleteToast, toastId } = t.toastProps || {};
      const handle = async (fnHandle) => {
        !!fnHandle && (await fnHandle());
        deleteToast();
      };
      return (
        <>
          <Dialog open={!!toastId} aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
            <DialogContent>
              <div>
                <div className="text-black">{message}</div>
                <div className="flex justify-center mt-5">
                  <LoadingButton
                    variant="contained"
                    color="success"
                    className="py-6 px-8 mx-6"
                    onClick={() => {
                      handle(handleBtnLeft);
                    }}
                  >
                    {textBtnLeft}
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="error"
                    className="py-6 px-8 mx-6"
                    onClick={() => {
                      handle(handleBtnRight);
                    }}
                  >
                    {textBtnRight}
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </>
      );
    },
    { style: { display: "none" } }
  );
};
